<template>
  <div class="contain">
    <!-- 검색 조건 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="{ tablet: 'top' }[$device.currentSize] ?? 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :sm="8">
            <el-form-item :label="$t('이벤트 코드명')">
              <el-input v-model="searchForm.actionNm" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('타입')">
              <code-combo
                :data="actionTp"
                :label="$t('전체')"
                :model="searchForm.actionTpCd"
                @change="searchForm.actionTpCd = $event.cd"></code-combo>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼-->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('ActionSearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('ActionAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('ActionUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('ActionDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('ActionAdd') || checkAuthActionAccess('ActionUp')"
        :size="size"
        @click="save"
        icon="el-icon-check"
        :disabled="btn.saveDisabled"
        style="float: right"
        class="hide-on-mobile"
        >{{ $t('저장') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-row :gutter="20">
      <el-col :md="16">
        <el-table
          :height="tableHeight"
          ref="table"
          border
          stripe
          highlight-current-row
          tooltip-effect="dark"
          :data="tableData"
          :size="size"
          :empty-text="$t('데이타 없음')"
          @row-click="handleRowClick"
          @select="handleRowChecked"
          @select-all="handleRowChecked">
          <el-table-column
            :label="tableData.length.toString()"
            type="index"
            width="55"
            align="center"
            sortable
            :fixed="!$device.mobile"
            label-class-name="data_cnt"></el-table-column>
          <el-table-column type="selection" width="45" align="center" :fixed="!$device.mobile"></el-table-column>
          <el-table-column
            :label="$t('코드')"
            prop="resourcesCd"
            width="70"
            align="center"
            sortable
            :fixed="!$device.mobile"></el-table-column>
          <el-table-column
            :label="$t('이벤트코드')"
            prop="actionId"
            width="120"
            sortable
            :fixed="!$device.mobile"
            show-overflow-tooltip></el-table-column>
          <el-table-column
            :label="$t('이벤트명')"
            prop="actionNm"
            min-width="150"
            sortable
            show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('타입')" prop="actionTp.nmLan" min-width="70" align="center"></el-table-column>
          <el-table-column
            :label="$t('주소')"
            prop="url"
            min-width="150"
            sortable
            show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('호출 타입')" prop="method" min-width="100" sortable></el-table-column>
          <el-table-column
            :label="$t('사용 가능 여부')"
            prop="useYn"
            min-width="110"
            align="center"
            :formatter="mainVue.formatterCode"></el-table-column>
          <el-table-column
            :label="$t('이벤트  설명')"
            prop="resDesc"
            min-width="300"
            show-overflow-tooltip></el-table-column>
        </el-table>
      </el-col>
      <el-col :md="8">
        <el-card shadow="never" :style="{ height: inputHeight + 'px' }" class="input-menu">
          <div slot="header">
            <span>{{ $t('이벤트') }}</span>
            <span v-if="'I' == inputForm.statu">{{ $t('추가') }}</span>
            <span v-if="'U' == inputForm.statu">{{ $t('수정') }}</span>
          </div>
          <div>
            <el-form
              :model="inputForm"
              :label-width="$device.mobile ? `` : `120px`"
              label-suffix=":"
              :size="size"
              :disabled="fromDisabled"
              @submit.native.prevent>
              <el-form-item :label="$t('이벤트코드')" :error="formError.actionId" required>
                <el-input
                  v-model="inputForm.actionId"
                  maxlength="50"
                  show-word-limit
                  clearable
                  v-if="'I' === inputForm.statu"></el-input>
                <span v-else class="show_cd">{{ inputForm.actionId }}</span>
              </el-form-item>
              <el-form-item :label="$t('이벤트명')" :error="formError.actionNm" required>
                <el-input v-model="inputForm.actionNm" maxlength="50" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('타입')" :error="formError['actionTp.nm']" required>
                <code-combo
                  :data="actionTp"
                  :model="inputForm.actionTp"
                  @change="inputForm.actionTp = $event"></code-combo>
              </el-form-item>
              <el-form-item :label="$t('주소')" :error="formError.url" required>
                <el-input v-model="inputForm.url" maxlength="50" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('호출 타입')" :error="formError.method" required>
                <combo
                  :data="mainVue.code.method"
                  :model="inputForm.method"
                  @change="inputForm.method = $event"></combo>
              </el-form-item>
              <el-form-item :label="$t('사용 가능 여부')" required>
                <combo :data="mainVue.code.useYn" :model="inputForm.useYn" @change="inputForm.useYn = $event"></combo>
              </el-form-item>
              <el-form-item :label="$t('이벤트  설명')">
                <el-input v-model="inputForm.resDesc" type="textarea" maxlength="250" show-word-limit></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()
    data.url = '/action'

    data.actionTp = []

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    return data
  },
  created: function () {
    this.search()
    this.initEvent()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    'inputForm.actionId': function (newVal, oldVal) {
      if ('' != newVal && 'I' == this.inputForm.statu) {
        this.chkActionId()
      }
    },
    'inputForm.actionNm': function (newVal, oldVal) {
      if ('' != newVal) {
        this.chkActionNm()
      }
    },
    'inputForm.url': function (newVal, oldVal) {
      if ('' != newVal) {
        this.chkUrlMethod()
      }
    },
    'inputForm.method': function (newVal, oldVal) {
      if ('' != newVal) {
        this.chkUrlMethod()
      }
    },
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        actionNm: '',
        actionTpCd: 0,
        useYn: '',
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        resourcesCd: 0,
        actionId: '',
        actionNm: '',
        actionTp: { cd: null, nm: '' },
        url: '',
        method: 'NONE',
        resDesc: '',
        useYn: 'Y',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        actionId: '',
        actionNm: '',
        'actionTp.nm': '',
        url: '',
        method: '',
        resDesc: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].resourcesCd
      }
    },
    // 이벤트 타입 데이타 초기화
    initEvent: function () {
      this.mainVue.$axios.search(
        '/code/getCode/EVENT',
        null,
        function (result) {
          this.actionTp = result
        }.bind(this),
        false
      )
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.inputForm.actionTp = this.actionTp.length > 0 ? util.copyObj(this.actionTp[0]) : { cd: null, nm: '' }

      this.formError = this.initFormError()

      this.btn.saveDisabled = false
      this.fromDisabled = false
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.resourcesCd,
        function (result) {
          result.statu = 'U'

          this.inputForm = result

          this.formError = this.initFormError()

          this.btn.saveDisabled = false
          this.fromDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true
          this.btn.saveDisabled = true
          this.fromDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('이벤트 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.resourcesCd,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.search()
          }.bind(this),
          true
        )
      }
    },
    // 이벤트 아이디 체크
    chkActionId: function () {
      this.mainVue.$axios.patchNonLoading(
        this.url + '/chk/' + this.inputForm.actionId,
        null,
        null,
        function (result) {
          if ('' == result) {
            this.formError.actionId = ''
            this.btn.saveDisabled = false
          } else {
            this.formError.actionId = this.$t('이미 사용중인 아이디입니다.')
            this.btn.saveDisabled = true
          }
        }.bind(this),
        false
      )
    },
    // 이벤트명 체크
    chkActionNm: function () {
      this.mainVue.$axios.patchNonLoading(
        this.url + '/chkNm/' + this.inputForm.actionNm,
        null,
        null,
        function (result) {
          if ('' == result || result.resourcesCd == this.inputForm.resourcesCd) {
            this.formError.actionNm = ''
            this.btn.saveDisabled = false
          } else {
            this.formError.actionNm = this.$t('이미 사용중인 이벤트명입니다.')
            this.btn.saveDisabled = true
          }
        }.bind(this),
        false
      )
    },
    chkUrlMethod: function () {
      if ('' != this.inputForm.url && '' != this.inputForm.method) {
        this.mainVue.$axios.patchNonLoading(
          '/resources/chk/' + this.inputForm.url.replace(/[/]/g, '-') + '/' + this.inputForm.method,
          null,
          null,
          function (result) {
            if ('' == result || result.resourcesCd == this.inputForm.resourcesCd) {
              this.formError.url = ''
              this.formError.method = ''
              this.btn.saveDisabled = false
            } else {
              this.formError.url = this.$t('이미 사용중인 주소, 호출 타입 조합 입니다.')
              this.formError.method = this.$t('이미 사용중인 주소, 호출 타입 조합 입니다.')
              this.btn.saveDisabled = true
            }
          }.bind(this),
          false
        )
      }
    },
  },
}
</script>
